import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { CodeNameRecord } from "api";
import { useDocumentService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";
import { mapApiExportReportParams } from "./useGetFormattedCsv";
import { valueOr } from "util/statHelpers";
import { useAuth } from "contexts/AuthProvider";

const mapApiValidEmailRecipientValues = (
  recipient: CodeNameRecord
): ValidCsvEmailRecipent => ({
  email: valueOr(recipient.Code),
  name: valueOr(recipient.Name),
});

const useGetValidCsvEmailRecipients = (
  cardCodes: string[],
  exportCsvParams: DownloadCsvParams
): UseQueryResult<ValidCsvEmailRecipent[]> => {
  const { username } = useAuth();
  const documentService = useDocumentService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useQuery({
    queryKey: [
      "get-valid-csv-email-recipients",
      { cardCodes },
      { exportCsvParams },
    ],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "/api/Report/GetValidRecipients",
      });
      return documentService
        .getValidCsvEmailRecipients(mapApiExportReportParams(exportCsvParams))
        .then((data) => data?.map(mapApiValidEmailRecipientValues))
        .catch((err) => {
          trackQueryError({ message: err.message }, eventId);
          throw err;
        });
    },
    select: (data) => data?.filter((recipient) => recipient.email !== username),
  });
};

export default useGetValidCsvEmailRecipients;
